import apiRequestType from "../apiRequestType";
import { apiTypes } from "../../utils/apiTypes";
import { apiConstants } from "../../utils/apiConstants";

const getTenantProfile = () => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.TenantDetail.GET_TENANT_PROFILE
  );
};

export default getTenantProfile;
